/**
 * Isometric Survival Game - Entry Point
 */

import { Game } from './Game';

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;
  const loadingElement = document.getElementById('loading');

  if (!canvas) {
    console.error('Canvas element not found!');
    return;
  }

  // Set canvas size
  canvas.width = 1024;
  canvas.height = 768;

  try {
    // Create and start the game
    const game = new Game(canvas);

    // Hide loading indicator
    if (loadingElement) {
      loadingElement.classList.add('hidden');
    }

    // Start the game loop
    game.start();

    // Expose game to console for debugging
    (window as unknown as { game: Game }).game = game;

    console.log('Game started! Controls:');
    console.log('  WASD - Move');
    console.log('  LMB - Attack/Gather');
    console.log('  I - Inventory');
    console.log('  C - Crafting');
    console.log('  B - Build');
    console.log('  1-0 - Hotbar');
    console.log('  ESC - Pause');
  } catch (error) {
    console.error('Failed to start game:', error);
    if (loadingElement) {
      loadingElement.textContent = 'Failed to load game. Check console for errors.';
    }
  }
});
